import React, { useState } from "react";
import EmailScreen from "./EmailScreen";
import WhatsappScreen from "./WhatsappScreen";
import translations from "../../translation"; // Import translations

const Screens = ({ content, title, name, language }) => {
  const [activeTab, setActiveTab] = useState("Email");

  const translate = (key) => translations[language][key] || key; // Translation function

  const renderActiveScreen = () => {
    if (activeTab === "Email") {
      return <EmailScreen content={content} title={title} name={name} language={language}/>;
    }
    if (activeTab === "Whatsapp") {
      return <WhatsappScreen content={content} title={title} name={name} language={language}/>;
    }
  };

  return (
    <div className="bg-white rounded p-3">
      <div className="d-flex justify-content-center mb-5">
        <button
          className={`btn ${
            activeTab === "Email" ? "btn-success" : "btn-danger"
          } me-2`}
          onClick={() => setActiveTab("Email")}
        >
          {translate("emailScreenButton")}
        </button>
        <button
          className={`btn ${
            activeTab === "Whatsapp" ? "btn-success" : "btn-danger"
          }`}
          onClick={() => setActiveTab("Whatsapp")}
        >
          {translate("whatsappScreenButton")}
        </button>
      </div>
      <div className="border shadow rounded p-2">{renderActiveScreen()}</div>
    </div>
  );
};

export default Screens;
